// extracted by mini-css-extract-plugin
export default {"templates":"dcOY2s","searchFadeIn":"xxakpu"};